import { CheckOutlined, CloseOutlined, WarningFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';

import s from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  status?: 'removed' | 'updated' | 'added' | 'unrecognized';
  message?: string;
  loadingAccept?: boolean;
  loadingIgnore?: boolean;
  disableAccept?: boolean;
  disableIgnore?: boolean;
  onAccept?: () => void;
  onIgnore?: () => void;
}

const MedicationItemFooter: FC<Props> = ({
  status,
  message,
  loadingAccept,
  loadingIgnore,
  disableAccept,
  disableIgnore,
  onAccept,
  onIgnore,
}) => {
  const { t } = useTranslation();

  if (!status) return null;

  const isUnrecognized = status === 'unrecognized';
  const displayStatus = isUnrecognized ? 'added' : status;

  const statusLabelMap = {
    removed: t('labels.medReconRemoved'),
    updated: t('labels.medReconUpdated'),
    added: t('labels.medReconAdded'),
  };

  return (
    <div className={s.footer}>
      <div className={s.left}>
        <span className={`${s.dot} ${s[`dot-${displayStatus}`]}`} />
        <span className={`${s.status} ${s[displayStatus]}`}>
          {statusLabelMap[displayStatus]}
        </span>
        {message && <span className={s.message}>{message}</span>}
        {isUnrecognized && (
          <span className={s['warning-message']}>
            <WarningFilled className={s['warning-icon']} />
            {t('labels.medReconUnrecognizedWarning')}
          </span>
        )}
      </div>
      <div className={s.right}>
        <BaseButton
          icon={<CheckOutlined className={s['icon-success']} />}
          type="secondary"
          loading={loadingAccept}
          disabled={disableAccept || isUnrecognized}
          onClick={onAccept}
          label={t('labels.accept')}
          className={s['accept-button']}
        />
        <BaseButton
          icon={<CloseOutlined />}
          loading={loadingIgnore}
          disabled={disableIgnore}
          onClick={onIgnore}
          label={t('labels.ignore')}
          type="secondary"
          className={s['ignore-button']}
        />
      </div>
    </div>
  );
};

export default MedicationItemFooter;
